(() => {
  document.body.classList.add('template-collection');

  const STORAGE_KEY = 'mc-collection-compare-v2';
  const maxItems = 3;

  function readItems() {
    try {
      const items = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items.slice(0, maxItems) : [];
    } catch (_) {
      return [];
    }
  }

  function writeItems(items) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function escapeHtml(value) {
    const node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function ensureTray() {
    let tray = document.querySelector('[data-mc-compare-tray]');
    if (tray) return tray;

    tray = document.createElement('aside');
    tray.className = 'mc-compare-tray';
    tray.dataset.mcCompareTray = '';
    tray.setAttribute('aria-label', 'Mattress comparison shortlist');
    tray.setAttribute('aria-live', 'polite');
    document.body.appendChild(tray);
    return tray;
  }

  const downloadIcon = '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18"><path d="M12 3v12m0 0 5-5m-5 5-5-5M5 19h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function reportMarkup(items, printable = false) {
    const guideLinks = [
      ['Find your ideal firmness', '/pages/mattress-firmness-guide'],
      ['Compare mattress types', '/pages/mattress-types-comparison'],
      ['Choose the right size', '/pages/mattress-size-guide'],
      ['Plan delivery and financing', '/pages/mattress-delivery-setup-financing'],
      ['Visit our Fairmont showroom', '/pages/mattress-store-fairmont-wv']
    ];
    return `
      <div class="mc-report-sheet ${printable ? 'is-printable' : ''}">
        <header class="mc-report-hero">
          <div><span class="mc-report-eyebrow">MATTRESS CENTRAL</span><h1>Your mattress comparison</h1><p>Use this shortlist to compare the essentials, then test your finalists side by side in our Fairmont showroom.</p></div>
          <div class="mc-report-date">${new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date())}</div>
        </header>
        <section class="mc-report-products" aria-label="Selected mattresses">
          ${items.map((item) => `
            <article class="mc-report-product">
              ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}">` : ''}
              <div class="mc-report-product__body">
                <span class="mc-report-vendor">${escapeHtml(item.vendor)}</span>
                <h2>${escapeHtml(item.title)}</h2>
                <strong class="mc-report-price">${escapeHtml(item.price)}</strong>
                <p>${escapeHtml(item.summary || 'See the product page for complete construction and comfort details.')}</p>
                <ul>${(item.features || []).slice(0, 3).map((feature) => `<li>${escapeHtml(feature)}</li>`).join('')}</ul>
                <a href="${escapeHtml(item.url)}">View mattress details →</a>
              </div>
            </article>`).join('')}
        </section>
        <section class="mc-report-advice">
          <div><span class="mc-report-eyebrow">SHOPPING TIP</span><h2>Let your body make the final decision</h2><p>Compare pressure relief, ease of movement, edge support and partner motion. Spend several minutes in your normal sleep position on each finalist.</p></div>
          <a class="mc-report-visit" href="/pages/mattress-store-fairmont-wv">Plan a showroom visit →</a>
        </section>
        <section class="mc-report-resources"><h2>Helpful next steps</h2><div>${guideLinks.map(([label, url]) => `<a href="${url}">${label}<span>→</span></a>`).join('')}</div></section>
        <footer><strong>Mattress Central</strong><span>316 Merchant Street, Fairmont, WV · (681) 404-6191 · wvmattress.com</span><small>Prices and availability may change. Confirm current details on each product page or with our showroom team.</small></footer>
      </div>`;
  }

  function openReport(items) {
    if (items.length < 2) return;
    document.querySelector('[data-mc-report-modal]')?.remove();
    const modal = document.createElement('div');
    modal.className = 'mc-report-modal';
    modal.dataset.mcReportModal = '';
    modal.innerHTML = `<div class="mc-report-modal__backdrop" data-mc-report-close></div><div class="mc-report-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="mc-report-title"><div class="mc-report-modal__toolbar"><div><strong id="mc-report-title">Mattress comparison report</strong><span>${items.length} mattresses selected</span></div><div><button type="button" class="mc-report-download" data-mc-report-download>${downloadIcon}<span>Download PDF</span></button><button type="button" class="mc-report-close" data-mc-report-close aria-label="Close comparison report">×</button></div></div><div class="mc-report-modal__scroll">${reportMarkup(items)}</div></div>`;
    document.body.appendChild(modal);
    document.body.classList.add('mc-report-open');
    requestAnimationFrame(() => modal.classList.add('is-open'));
    modal.querySelector('[data-mc-report-close]').focus();
  }

  function printReport(items) {
    const printWindow = window.open('', '_blank', 'noopener,noreferrer');
    if (!printWindow) return;
    const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style')).map((node) => node.outerHTML).join('');
    printWindow.document.write(`<!doctype html><html><head><title>Mattress Central comparison</title><meta name="viewport" content="width=device-width,initial-scale=1">${styles}<style>body{margin:0;background:#fff}.mc-report-sheet{max-width:1100px;margin:0 auto}.mc-report-modal__toolbar{display:none!important}@media print{a{color:inherit;text-decoration:none}.mc-report-sheet{max-width:none}}</style></head><body>${reportMarkup(items, true)}</body></html>`);
    printWindow.document.close();
    printWindow.addEventListener('load', () => window.setTimeout(() => printWindow.print(), 350));
  }

  function render() {
    const items = readItems();
    document.querySelectorAll('[data-mc-compare]').forEach((button) => {
      const selected = items.some((item) => item.id === button.dataset.productId);
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
      const mark = button.querySelector('.mc-compare-check');
      if (mark) mark.textContent = selected ? '✓' : '+';
      const label = button.querySelector('.mc-compare-label');
      if (label) label.textContent = selected ? 'Added to compare' : 'Compare';
    });

    const tray = ensureTray();
    tray.classList.toggle('is-visible', items.length > 0);
    tray.innerHTML = items.length ? `
      <div class="mc-compare-tray__head">
        <div><strong>Compare your shortlist</strong><span>${items.length} of ${maxItems} selected</span></div>
        <button type="button" class="mc-compare-tray__clear" data-mc-compare-clear>Clear all</button>
      </div>
      <div class="mc-compare-tray__body">
        <div class="mc-compare-tray__items">
          ${items.map((item) => `
            <article>
              ${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : ''}
              <div><small>${escapeHtml(item.vendor)}</small><strong>${escapeHtml(item.title)}</strong><span>${escapeHtml(item.price)}</span></div>
              <a href="${escapeHtml(item.url)}">View</a>
              <button type="button" data-mc-compare-remove="${escapeHtml(item.id)}" aria-label="Remove ${escapeHtml(item.title)}">×</button>
            </article>`).join('')}
        </div>
        <div class="mc-compare-tray__actions">
          <button type="button" class="mc-compare-report" data-mc-compare-report ${items.length < 2 ? 'disabled' : ''}>${downloadIcon}<span>Generate PDF report</span></button>
          <span>${items.length < 2 ? 'Choose at least 2 mattresses' : 'Ready to compare side by side'}</span>
        </div>
      </div>` : '';
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mc-compare]');
    if (button) {
      const items = readItems();
      const index = items.findIndex((item) => item.id === button.dataset.productId);
      if (index >= 0) {
        items.splice(index, 1);
      } else if (items.length < maxItems) {
        const card = button.closest('.grid__item') || button.parentElement;
        items.push({
          id: button.dataset.productId,
          title: button.dataset.title,
          vendor: button.dataset.vendor,
          price: button.dataset.price,
          url: button.dataset.url,
          image: button.dataset.image,
          summary: button.dataset.summary,
          features: Array.from(card.querySelectorAll('.mc-card-facts span')).map((node) => node.textContent.trim())
        });
      } else {
        button.animate(
          [{ transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'none' }],
          { duration: 220 }
        );
        return;
      }
      writeItems(items);
      render();
      return;
    }

    const remove = event.target.closest('[data-mc-compare-remove]');
    if (remove) {
      writeItems(readItems().filter((item) => item.id !== remove.dataset.mcCompareRemove));
      render();
      return;
    }

    if (event.target.closest('[data-mc-compare-clear]')) {
      writeItems([]);
      render();
      return;
    }

    if (event.target.closest('[data-mc-compare-report]')) {
      openReport(readItems());
      return;
    }

    if (event.target.closest('[data-mc-report-download]')) {
      printReport(readItems());
      return;
    }

    if (event.target.closest('[data-mc-report-close]')) {
      document.querySelector('[data-mc-report-modal]')?.remove();
      document.body.classList.remove('mc-report-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.querySelector('[data-mc-report-modal]')) {
      document.querySelector('[data-mc-report-modal]').remove();
      document.body.classList.remove('mc-report-open');
    }
  });

  document.addEventListener('shopify:section:load', render);
  document.addEventListener('DOMContentLoaded', render);
  render();
})();
